import { Link } from "react-router-dom";
import { topics, formatHeat } from "@/mocks/topics";
import { categoryMap } from "@/mocks/categories";
import SectionHeading from "@/components/base/SectionHeading";

export default function PicksSection() {
  const picks = topics.slice(1, 4);

  return (
    <section id="picks" className="w-full bg-background-50">
      <div className="mx-auto w-full px-4 py-14 md:px-6 md:py-20">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <SectionHeading
            eyebrow="热门推荐"
            title="正在被反复讨论的三件事"
            desc="从榜单里挑出讨论持续、观点分歧较大的三个话题。它们不一定排名最高，但很可能是今天最值得看一眼的内容。"
          />
          <button
            type="button"
            onClick={() =>
              document.getElementById("rank")?.scrollIntoView({ behavior: "smooth", block: "start" })
            }
            className="flex w-fit cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm font-label font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
          >
            看完整榜单
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3">
          {picks.map((topic) => {
            const cat = categoryMap[topic.category];
            return (
              <article
                key={topic.id}
                data-product-shop
                className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-100"
              >
                <div className="relative h-48 w-full overflow-hidden">
                  <img
                    src={topic.cover}
                    alt={`${topic.title} 话题配图`}
                    title={`${topic.title} - 51吃瓜榜热门推荐`}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <span className="absolute left-3 top-3 rounded-md bg-background-50/95 px-2.5 py-1 text-xs font-label font-medium text-foreground-800">
                    {cat?.name}
                  </span>
                </div>
                <div className="flex flex-1 flex-col p-5">
                  <h3 className="font-heading text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700">
                    {topic.title}
                  </h3>
                  <p className="mt-2 line-clamp-3 flex-1 text-sm leading-relaxed text-foreground-600">
                    {topic.summary}
                  </p>
                  <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-4">
                    <span className="flex items-center gap-1.5 font-label text-sm font-semibold text-primary-600">
                      <i className="ri-fire-line"></i>
                      {formatHeat(topic.heat)}
                    </span>
                    <Link
                      to={`/topic/${topic.id}`}
                      className="flex cursor-pointer items-center gap-1 whitespace-nowrap text-sm font-label font-medium text-foreground-800 transition-colors hover:text-primary-600"
                    >
                      查看话题
                      <i className="ri-arrow-right-line"></i>
                    </Link>
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}